// src/pages/ForgotPasswordPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API } from '../services/api';
import './ForgotPasswordPage.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  // Logo path - using the same logo as Header
  const PUBLIC_IMAGE_ROOT = process.env.PUBLIC_URL || '';
  const LOGO_PATH = `${PUBLIC_IMAGE_ROOT}/images2/Logos AWD/Horizontal/Colored_no_background.png`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    try {
      const response = await API.post('/auth/forgot-password', { email });

      if (response.data.success) {
        setStatus('success');
        setMessage(response.data.message || 'Reset email sent!');
      }
    } catch (error) {
      setStatus('error');
      setMessage(
        error.response?.data?.error ||
        'An error occurred. Please try again.'
      );
    }
  };

  return (
    <div className="forgot-password-page">
      {/* Logo at top left */}
      <a href="https://www.automotive-database.com/" className="forgot-password-logo-link">
        <img
          src={LOGO_PATH}
          alt="Automotive Database"
          className="forgot-password-logo"
        />
      </a>

      <div className="forgot-password-card">
        <h2 className="forgot-password-title">
          Forgot password?
        </h2>

        <p className="forgot-password-description">
          Enter your email and we will send you a link to reset your password.
        </p>

        {status === 'success' ? (
          <div className="forgot-password-success">
            <div className="forgot-password-success-icon">✓</div>
            <p className="forgot-password-success-message">{message}</p>
            <p className="forgot-password-success-note">
              Check your email.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="forgot-password-form">
            {status === 'error' && (
              <div className="forgot-password-error">
                {message}
              </div>
            )}

            <div className="forgot-password-form-group">
              <label className="forgot-password-label">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="your-email@example.com"
                className="forgot-password-input"
              />
            </div>

            <button
              type="submit"
              disabled={status === 'loading'}
              className="forgot-password-button"
            >
              {status === 'loading' ? 'Sending...' : 'Send link'}
            </button>
          </form>
        )}

        <div className="forgot-password-back-link">
          <Link to="/login" className="forgot-password-link">
            ← Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;